import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ArrowRightIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { globalConst } from 'modules/global';

import { Visible } from 'components';

import { lessonConst, setPaymentModal } from '..';

interface IProps {
  desc?: string;
  isBought?: boolean;
  nextLessonSlug?: string;
}

export const InfoSection = ({ desc, isBought, nextLessonSlug }: IProps) => {
  const t = useTranslations();
  const qc = useQueryClient();
  const dispatch = useAppDispatch();
  const { push, query } = useRouter();

  const onNext = () => {
    if (!isBought) {
      return dispatch(setPaymentModal(true));
    }

    qc.invalidateQueries({ queryKey: [lessonConst.queryKeys.LESSONS_LIST, query?.course as string] });
    return push(`${globalConst.pageNames.COURSES}/${query?.course}/${nextLessonSlug}`);
  };

  return (
    <>
      <Visible if={desc}>
        <div className="space-y-1.5 rounded-xl bg-white p-5">
          <div className="font-semibold">{t('dars_haqida')}</div>
          <p className="text-sm">{desc}</p>
        </div>
      </Visible>
      <Visible if={nextLessonSlug}>
        <div className="my-7 flex items-center justify-center">
          <button
            onClick={onNext}
            className="flex cursor-pointer items-center justify-center gap-2 rounded-lg bg-green-500 px-5 py-2.5 text-sm font-medium text-white disabled:cursor-not-allowed disabled:opacity-50"
          >
            {t('keyingi_dars')} <ArrowRightIcon />
          </button>
        </div>
      </Visible>
    </>
  );
};
